export const VIEW_OFFER_DETAILS = "View Offer Details";

export const NO_OFFERS_AVAIL_TITLE = "You don’t have any travel offers.";
export const NO_OFFER_AVAIL_BODY =
  "We’ll notify you when travel offers become available.";

export const HSP_OFFER_TITLE_LABEL =
  "Congrats, you have two hotel offers to choose from:";
